import {
    IssuesDto,
    IssueSingleDto,
    CreateIssueCommentDto,
    IssueItemDto,
    ClassifierResponseDto,
    CreateIssueResponseDto,
    CreateIssueRequestDto
} from '../../types';
import IssuesApi from '../';

const issues = new IssuesApi();

export const getIssues = async (): Promise<IssuesDto | undefined> => {
    return await issues.getIssues();
};
export const getSingleIssue = async (issueId: number): Promise<IssueSingleDto | undefined> => {
    return await issues.getSingleIssue(issueId);
};

export const createIssueComment = async (issueId: number, issueComment: CreateIssueCommentDto): Promise<IssueItemDto | undefined> => {
    return await issues.createIssueComment(issueId, issueComment);
};

export const getIssueCategories = async (): Promise<ClassifierResponseDto | undefined> => {
    return await issues.getIssueCategories();
};

export const getIssueTypes = async (): Promise<ClassifierResponseDto | undefined> => {
    return await issues.getIssueTypes();
};

export const createMyIssue = async (issue: CreateIssueRequestDto): Promise<CreateIssueResponseDto | undefined> => {
    return await issues.createMyIssue(issue);
};

export const getClassifiers = async (classifiers: string): Promise<ClassifierResponseDto[] | undefined> => {
    return await issues.getClassifiers(classifiers);
};

export const createIssue = async (issue: CreateIssueRequestDto): Promise<CreateIssueResponseDto | undefined> => {
    return await issues.createIssue(issue);
};

export const getIssueAttachment = async (issuesId: number, attachmentId: string): Promise<Response | undefined> => {
    return await issues.getIssueAttachment(issuesId, attachmentId);
};
